require('./bootstrap');
var LocationDetectorModule = require('./modules/locationDetector');
var UserInteractModule = require('./modules/userInteractEvent');

UserInteractModule.init();

$(document).ready(function () {
    window.baseUrl = process.env.MIX_APP_URL;

    require('./mixins/indexOf')
    require('./mixins/change-locale')

    require('./mixins/menu')
    require('./mixins/slider')
    require('./mixins/tooltip')
    require('./mixins/popup')
    require('./mixins/scroll')
    require('./mixins/accordion')
    require('./mixins/validator')
    require('./mixins/copy-link')
    require('./mixins/close-popup')

    $('.form_container input, .form_container textarea').keyup(function() {
        var val = $(this).val();
        var par = $(this).parents('.form-group');
        if (val != '') {
            par.find('label.hid').addClass('active');
        } else {
            par.find('label.hid').removeClass('active');
        }
    });

    $(document).find('.select2-init:not(.no-search)').select2();

    $(document).find('.select2-init.no-search').select2({
        minimumResultsForSearch: Infinity
    });

    LocationDetectorModule.init();
});

// Reload page if bfcache present
window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        location.reload();
    }
});
